import { FileEarmarkPlus } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

function NoTemplate() {
  const { t } = useTranslation();

  return (
    <div className="text-center">
      <FileEarmarkPlus size={30} className="mx-auto" />
      <h3 className="mt-2 text-sm font-semibold text-gray-900">
        {t("dashboard_no_templates_title")}
      </h3>
      <p className="mt-1 text-sm text-gray-500">
        {t("dashboard_no_templates_body")}
      </p>
    </div>
  );
}

export default NoTemplate;
